<script setup>
  import { ref, onMounted } from 'vue';

  import { useBulletinStore } from "@/stores/BulletinStore";
  import { useSpotStore } from "@/stores/SpotStore";

  import useLegacyBridge from "@/composables/useLegacyBridge";

  const content = defineModel();

  const bulletinStore = useBulletinStore();
  const spotStore = useSpotStore();

  const { marineForecast } = useLegacyBridge();

  const contentContainer = ref(null);
  
  function loadMarineForecast() {
    const settings = {
      lat: spotStore.lat,
      lon: spotStore.lon,
      spotId: spotStore.spotId,
      bulletinsData: bulletinStore.bulletinsData,
      timezoneName: spotStore.localTimezone
    }       
    
    content.value = marineForecast(contentContainer.value, settings);
  }

  onMounted(() => loadMarineForecast());
</script>

<template>
  <div
    class="jwx-data-container__content"
    style="width: 100%;"
    ref="contentContainer"
  ></div>
</template>